const colorAccent = "#5175ff";
const colorAccentPale = "#829cff";
const colorBgDark = "#25293a";
const colorBgLight = "#fafafa";
const colorLightBlue = "#e4eafe";
const colorPrimary = "#333950";
const colorSecondary = "#747b95";
const colorSecondaryLight = "rgba(116, 123, 149, 0.5)";
const colorUiError = "#f05b5b";

export {
  colorAccent,
  colorAccentPale,
  colorBgDark,
  colorBgLight,
  colorLightBlue,
  colorPrimary,
  colorSecondary,
  colorSecondaryLight,
  colorUiError,
};
